import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { HESTIA2_OPTIONS } from '@/lib/statOptions'

interface ExchangeStep4Props {
    formData: any
    onSubmit: (data: any) => void
    onBack: () => void
    onNavigateHome: () => void
    showConfirm: boolean
    onConfirmNavigateHome: () => void
    onCancelConfirm: () => void
}

export const ExchangeStep4 = ({
    formData,
    onSubmit,
    onBack,
    onNavigateHome,
    showConfirm,
    onConfirmNavigateHome,
    onCancelConfirm
}: ExchangeStep4Props) => {
    const [hestia2, setHestia2] = useState({
        securite: formData.hestia2?.securite || "3: Logement parfaitement utilisé, totalement sain et fonctionnel",
        sante: formData.hestia2?.sante || "3: Autonomie dans la prise du traitement, bon lien avec médecin traitant et/ou infirmière à domicile",
        consommation: formData.hestia2?.consommation || "3: Absence de consommation(s) - abstinence"
    })

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        onSubmit(hestia2)
    }

    const { securite, sante, consommation } = HESTIA2_OPTIONS

    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-4xl mx-auto px-4">
                <h1 className="text-3xl font-bold text-gray-900 mb-8">Score HESTIA - Risque de décès</h1>

                <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-8">
                    <div className="space-y-8">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Sécurité</h3>
                            <div className="space-y-2">
                                {securite.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="securite"
                                            value={option}
                                            checked={hestia2.securite === option}
                                            onChange={(e) => setHestia2({ ...hestia2, securite: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Santé</h3>
                            <div className="space-y-2">
                                {sante.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="sante"
                                            value={option}
                                            checked={hestia2.sante === option}
                                            onChange={(e) => setHestia2({ ...hestia2, sante: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-4">Consommation</h3>
                            <div className="space-y-2">
                                {consommation.map(option => (
                                    <label key={option} className="flex items-start">
                                        <input
                                            type="radio"
                                            name="consommation"
                                            value={option}
                                            checked={hestia2.consommation === option}
                                            onChange={(e) => setHestia2({ ...hestia2, consommation: e.target.value })}
                                            className="mr-3 mt-1"
                                        />
                                        <span className="text-sm">{option}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-between mt-8">
                        <Button type="button" variant="outline" onClick={onBack}>
                            Retour
                        </Button>
                        <div className="space-x-4">
                            <Button type="button" variant="outline" onClick={onNavigateHome}>
                                Accueil
                            </Button>
                            <Button type="submit">
                                Suivant
                            </Button>
                        </div>
                    </div>
                </form>
            </div>

            {showConfirm && (
                <ConfirmDialog
                    onConfirm={onConfirmNavigateHome}
                    onCancel={onCancelConfirm}
                />
            )}
        </div>
    )
} 